import React from "react";

import HealthImg1 from "assets/images/health-img1.png";
import HealthImg2 from "assets/images/health-img2.png";
import HealthImg3 from "assets/images/health-img3.png";
import HealthImg4 from "assets/images/health-img4.png";
import HealthImg5 from "assets/images/health-img5.png";

const Common = () => {
  return (
    <>
      <div className="cardbox-wrapper card-item1 d-flex align-items-center justify-content-center">
        <div className="iconbox">
          <img src={HealthImg1} alt="" />
        </div>
      </div>
      <div className="cardbox-wrapper card-item2 d-flex align-items-center justify-content-center">
        <div className="iconbox">
          <img src={HealthImg2} alt="" />
        </div>
      </div>
      <div className="cardbox-wrapper card-item3 d-flex align-items-center justify-content-center">
        <div className="iconbox">
          <img src={HealthImg3} alt="" />
        </div>
      </div>
      <div className="cardbox-wrapper card-item4 d-flex align-items-center justify-content-center">
        <div className="iconbox">
          <img src={HealthImg4} alt="" />
        </div>
      </div>
      <div className="cardbox-wrapper card-item5 d-flex align-items-center justify-content-center">
        <div className="iconbox">
          <img src={HealthImg5} alt="" />
        </div>
      </div>
    </>
  );
};

export { Common };